import { getLocalSettingsOrDefault, setLocalSettings } from "./localSettings";

export const definedDatePickerRanges = {
    'Today': [moment().utc(), moment().utc()],
    'Yesterday': [moment().utc().subtract(1, 'days'), moment().utc().subtract(1, 'days')],
    'Last 7 Days': [moment().utc().subtract(6, 'days'), moment().utc()],
    'Last 30 Days': [moment().utc().subtract(29, 'days'), moment().utc()],
    'This Month': [moment().utc().startOf('month'), moment().utc().endOf('month')],
    'Last Month': [moment().utc().subtract(1, 'month').startOf('month'), moment().utc().subtract(1, 'month').endOf('month')],
    'All Time': [moment().utc().subtract(1, 'years'), moment().utc()],
};

export function getRangeByName(name) {
    const range = definedDatePickerRanges[name];

    return range;
}

export function getDefaultRangeName() {
    return 'Last 7 Days';
}

export function serializeDateRange(key, valArr) {
    const rangeName = valArr[2];

    if (getRangeByName(rangeName)) {
        setLocalSettings(key, [null, null, rangeName]);
    } else {
        setLocalSettings(key, [valArr[0], valArr[1], null]);
    }
}

export function prepareSerializedDateRange(key) {
    const defaultOne = getRangeByName(getDefaultRangeName());

    const saved = getLocalSettingsOrDefault(key, [...defaultOne, getDefaultRangeName()]);

    if (saved && saved[2]) {
        return [...getRangeByName(saved[2]), saved[2]];
    } else {
        return [moment(saved[0]), moment(saved[1]), null];
    }
}